export const SIGNIN_ENDPOINT = '/api/dashboard/login/';
export const DASHBOARD_ENDPOINT = '/api/dashboard/register/';
export const REGISTER_MULTIPLE_USER = '/api/dashboard/add_multiple_user_to_company/';
export const SIGNOUT_ENDPOINT = '/api/dashboard/logout/';
export const ATTACH_PLAN_ENDPOINT = '/api/dashboard/attach_plan/';
/** GET preview for Pro Conversion CTA (admin / company / plan / blueprint snapshot + can_attach_plan). */
export const ATTACH_PLAN_INFO_ENDPOINT = '/api/dashboard/attach_plan_info/';
export const FEATURE_REPORT_ENDPOINT = '/api/dashboard/feature_report/';
export const CONVERT_TO_ENTERPRISE = '/api/dashboard/convert_to_enterprise/';
export const INCREASE_FREE_TRIAL_ENDPOINT = '/api/dashboard/start_freetrial/';
export const FREE_PROPERTY_DETAILS_ENDPOINT = '/api/dashboard/free_property/';
export const COMPANY_DETAILS = '/api/dashboard/company_details/';
export const DOWNLOAD_COMPANY_DETAILS = '/api/dashboard/download_company_data/';
export const USAGE_SUMMARY_ENDPOINT = '/api/dashboard/usage_report/';
export const INVITE_USER_ENDPOINT = '/api/dashboard/add_user_to_company/';
export const DOWNLOAD_PRO_EXPIRED_USERS_LIST = '/api/dashboard/pro_expired/';
export const ENTERPRISE_CONTRACTS = '/api/dashboard/enterprise_billing/';
export const DOWNLOAD_USAGE_SUMMARY_USL = '/api/companies/%s/monthly_report/';
export const DOWNLOAD_USAGE_SUMMARY_GG_ENDPOINT = '/api/dashboard/ground_guys_report/';
export const CHANGE_PASSWORD = '/api/dashboard/change_password/';
export const BLOCK_USER = '/api/dashboard/block_user/';
export const UNBLOCK_USER = '/api/dashboard/unblock_user/';
export const CONVERT_TO_PRO = '/api/dashboard/convert_enterprise_to_pro/';
export const GET_VALIDATE_STATUS_REQUESTS = '/api/dashboard/validate_requests/';
export const APPROVE_REQUESTS = '/api/dashboard/approve_requests/';
export const GET_OPTIONAL_FEATURES = '/api/dashboard/default_company_optional_features/';
export const USER_MFA_DISABLE_ENDPOINT = '/api/dashboard/reset_user_mfa/';
export const PRO_PRICING_CONVERSION_ENDPOINT = '/api/dashboard/toggle_show_pro_pricing/';

export const DOWNLOAD_ENTERPRISE_CONTRACT = '/api/dashboard/download_enterprise_billing/';

// Copy and Transfer Requests
export const FMS_UPLOAD = '/api/admin/requests/fms_upload/';
export const TRANSFER_REQUEST = '/api%s/transfer_requests/';
export const BULK_DUPLICATE = '/api%s/bulk_duplicate/';
export const CHANGE_OWNER = '/api%s/change_owner/';

// Update Contract for Enterprise
export const GET_ENTERPRISE_DETAILS = '/api/dashboard/enterprise_info/?email=%s';
export const ENTERPRISE_INFO = '/api/dashboard/enterprise_info/';
export const UPDATE_ENTERPRISE = '/api/dashboard/update_enterprise/';
export const COMPANY_SCOPES = '/api/dashboard/company_scopes/';

// Create Feature Report
export const CREATE_FEATURE_ENDPOINT = '/api/dashboard/create_feature/';
export const FOLDER_EXPORT = '/api/dashboard/folder_export/';

// Portfolio
export const PORTFOLIO_ENDPOINT = '/api/portfolio/';
export const PORTFOLIO_UPDATE = '/api/portfolio/%s/';
export const PORTFOLIO_EXECUTE = '/api/portfolio/%s/execute/';

// Company Usage
export const COMPANY_USAGE_ENDPOINT = '/api/dashboard/company_usage/';
export const EMAIL_COMPANY_USAGE = '/api/dashboard/download_company_usage/';

// Coupon
export const COUPONS_ENDPOINT = '/api/coupon/';
export const COUPON_EDIT = '/api/coupon/%s/';

// Promotional Programs
export const PROMOTIONAL_ENDPOINT = '/api/promotional_program/';
export const PROMOTIONAL_EDIT = '/api/promotional_program/%s/';

// Folder Requests
export const FOLDER_REQUESTS_ENDPOINT = '/api/dashboard/get_folder_requests/';

// categories
export const GET_CATEGORIES = '/api/estimator-sheets/categories/';
export const GET_CATEGORIES_ON_FALCON = '/api/user-sheets/categories/';

// Enable Platform Access
export const ENABLE_PLATFORM_ACCESS = '/api/dashboard/fetch_platform_access/';
export const DISABLE_PLATFORM_ACCESS = '/api/dashboard/disable_platform_access/';
export const UPDATE_PLATFORM_ACCESS = '/api/dashboard/update_platform_access/';

// Request On Hold
export const PUT_REQUEST_ON_HOLD = '/api/admin/requests/put_request_on_hold/';
export const RESUME_ON_HOLD_REQUEST = '/api/admin/requests/resume_on_hold_request/';

// Rosetta
export const GET_ROSETTA_DATA = '/api/dashboard/get_scopes/';
export const GENERATE_ESTIMATE_PDF = '/api/dashboard/generate_estimate_pdf/';

// Multi trade User management
export const GET_TRADES = '/api/dashboard/trade_configs/';
export const GET_COMPANY_TRADES = '/api/dashboard/company_trade_configs/';
export const UPDATE_TRADES = '/api/dashboard/update_company_trade_configs/';

// Beam Module Management
export const GET_ENABLE_WINDOW = '/api/dashboard/get_enable_window/';
export const MANAGE_ENABLE_WINDOW = '/api/dashboard/manage_enable_window/';

// Bid Team Management
export const BID_TEAM_ENDPOINT = '/api/dashboard/company_bidboard_emails/';
export const DELETE_BID_TEAM_MEMBER = '/api/dashboard/company_bidboard_emails/%s/';

// API tools
export const USER_API_TOKENS = '/api/dashboard/token/';
export const USER_API_TOKEN_DETAIL = '/api/dashboard/token/%s/';
export const USER_API_TOKEN_SHARE_TOKEN = '/api/dashboard/token/%s/share_token/';
export const ENTERPRISE_CALLBACKS = '/api/dashboard/enterprise_callback/';
export const ENTERPRISE_CALLBACK_DETAIL = '/api/dashboard/enterprise_callback/%s/';
export const ALL_BEARER_CALLBACKS = '/api/dashboard/all_bearer_callback/';
export const BEARER_CALLBACK = '/api/dashboard/bearer_callback/';

// DIY Entitlement
export const GET_DIY_ENTITLEMENT = '/api/dashboard/diy_info/';
export const UPDATE_DIY_ENTITLEMENT = '/api/dashboard/update_diy_entitlement/';
export const RESET_DIY_COUNTERS = '/api/dashboard/reset_diy_counters/';
export const COMMERCIAL_CONFIG_AUDIT_LOG = '/api/dashboard/commercial_config_audit_log/';

// Update Company
export const UPDATE_COMPANY_ENDPOINT = '/api/dashboard/update_company/';

// Customer Support Session
export const SUPPORT_SESSION_ISSUE_HANDOFF_HASH = '/api/dashboard/issue_handoff_hash/';

// Scope Console (Rosetta 2)
export const SCOPE_RECORDS_ENDPOINT = '/api/dashboard/scope-records/';
export const SCOPE_RECORD_DETAIL_ENDPOINT = '/api/dashboard/scope-records/%s/';
export const SCOPE_RECORD_LINK_ENDPOINT = '/api/dashboard/scope-records/%s/link/';
export const SCOPE_RECORD_LINK_COMPANY_ENDPOINT = '/api/dashboard/scope-records/%s/link-company/';
export const SCOPE_RECORD_UNLINK_COMPANY_ENDPOINT = '/api/dashboard/scope-records/%s/unlink-company/';
export const SCOPE_RECORD_RESEND_INVITE_ENDPOINT = '/api/dashboard/scope-records/%s/resend-invite/';
export const SALES_TEAM_MEMBERS_ENDPOINT = '/api/users/sales_team_members/';
export const COMPANY_LOOKUP_ENDPOINT = '/api/dashboard/company-lookup/';
